import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import styled from "styled-components";
import { useCityName } from "@/utils/customHooks/useCityName";
import { extractResource } from "../../../helper/extractResource";
import CheckCircleSolid from "../../../public/svg/CheckCircleSolid";
import { RightArrow } from "../../../public/svg/RightArrow";
import { getSegmentLevelDetails } from "../../../services/addons/addons";
import { checkForPaxSeatInfo } from "../../../services/checkin";
import { checkedInUsersBySegmentKey } from "../../../services/checkin/checkedInUserBySegmentkey";
import cssStyle from "./checkIn.module.css";
import { checkForInternationalBooking } from "@/services/flightsDetails/checkForInternationalFlights";
import { useCommonContext } from "context/CommonDataContext";
import { useSelector } from "react-redux";
import { Button } from "components/UI/Button";
import hasNotOpenedRestriction from "./helperFunctions/displayCheckInStatusMsg";

const CheckingText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.375rem;
  color: #666666;
`;
const Date = styled.p`
  margin: 0;
  margin-bottom: 0.25rem;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
  color: #333333;
`;
const Mon = styled.p`
  margin: 0;
  margin-bottom: 0.25rem;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  color: #333333;
`;
const FCal = styled.div`
display:flex;
flex-direction:column;
justify-content:space-between;
align-items:center;
margin:0.5rem;
margin-left:0;
margin-right:0;
padding-left:0.5rem;
padding-right:0.5rem;
height: fit-content;
padding-top:0.5rem
background: #FFFFFF;
box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
border-radius: 4px;
`;

const FCal1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-item: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-item: start;
  margin-top: 5px;
`;

function ResCallenders(props: any) {
  const [paxSeats, setPaxSeats]: any = useState({});
  const [segments, setSegments]: any = useState({});
  const { resourceData } = props;
  const cityName = useCityName();
  const { resources } = useCommonContext();

  const groupBooking = useSelector((state: any) => state.persistedReducers.groupBooking);

  const timelapse = "/svg/delayed_icon_gray.svg";
  const AccessTime = "/svg/time.svg";

  const displayStops = (stops: number) => {
    if (stops === 0) {
      return extractResource(resourceData, "stops").zero;
    }
    if (stops === 1) {
      return extractResource(resourceData, "stops").one;
    }
    if (stops === 2) {
      return extractResource(resourceData, "stops").two;
    }
    return extractResource(resourceData, "stops").two.replace("{}", stops);
  };

  const initValues = async () => {
    const paxSeatInfo = await checkForPaxSeatInfo(props?.currentBookingInState?.data?.data);
    const responseSegments = getSegmentLevelDetails(props?.currentBookingInState?.data?.data);
    if(responseSegments){
      if(groupBooking){
        setSegments(responseSegments?.filter((segment) => segment.isAnyCheckedIn && segment.displayStatus ))
      }else{
        setSegments(responseSegments?.filter((segment) => segment.isAnyCheckedIn === true))
      }
    }
    setPaxSeats(paxSeatInfo);
  };

  useEffect(() => {
    initValues();
  }, []);

  const handleEye = (e, paxKey, segmentKey, isInfant = false) => {
    const url = `/print-boarding-pass?segmentKey=${segmentKey}&paxKey=${paxKey}&isInfant=${isInfant}`;
    if (window) {
      const win = window.open(url, "_blank");
      win.focus();
    }
  };
  return (
    <>
      {Array.isArray(segments) && segments?.length > 0 && segments?.map((ele, id) => {
          const passangers = checkedInUsersBySegmentKey({
            bookingInfo: props?.currentBookingInState?.data?.data,
            segmentKey: ele.key
          });
          return (
            <FCal key={id}>
              <FCal1>
                <Box className={cssStyle.JourneyDetails}>
                  <div className="w-12 h-auto px-6 rounded bg-gray-200">
                    <div className={cssStyle.DateMonth}>
                      <Date> {moment(ele?.departure).format(" D")}</Date>
                      <Mon>{moment(ele?.departure).format(" MMM")}</Mon>
                    </div>
                  </div>
                  <Box className={cssStyle.widthFifty}>
                    <div className="flex items-start mt-1 px-2">
                      <p className="font-semibold text-sm flex items-center text-typography-primary">
                        {cityName(ele.org)}
                      </p>
                      <div className="mt-1 mx-1">
                        <RightArrow />
                      </div>
                      <p className="font-semibold text-sm flex items-center text-typography-primary">
                        {cityName(ele.dest)}
                      </p>
                    </div>
                    <p className="text-xs flex items-center pt-2 text-typography-secondary mx-2">
                      {displayStops(ele.legKeys.length - 1)}
                      {ele.legKeys.length > 0
                        ? ele.journeyDetails?.segments.map((itm, id) =>
                            ele.journeyDetails?.segments.length == id + 1 && ele.journeyDetails.segments.length > 1
                              ? null
                              : itm.legs[0].designator.destination
                          )
                        : null}
                      &nbsp;•&nbsp;
                      {(ele?.identifier?.carrierCode + " " + ele?.identifier?.identifier).toString()?.replace(",", " ")}
                    </p>
                    {ele.passengerSegment.filter((data) => data?.liftStatus == "CheckedIn").length != ele.passengerSegment.length &&
                     ele.passengerSegment.filter((data) => data?.liftStatus == "CheckedIn").length != 0 ? (
                      <div className="text-xs flex items-center pt-2 mx-2 text-typography-secondary">
                        {!groupBooking && (
                          <>
                            <img src={timelapse} alt="timelapse" />
                            &nbsp;
                            {ele.passengerSegment.filter((data) => data?.liftStatus === "CheckedIn").length}/{ele.passengerSegment.length}
                            &nbsp;
                          </>
                        )}
                        {extractResource(resourceData, "checkedin")}
                      </div>
                    ) : ele.passengerSegment.filter((data) => data?.liftStatus == "CheckedIn").length ==
                      ele.passengerSegment.length ? (
                      <div className="flex ml-2 items-center justify-start mt-1 text-typography-success gap-1">
                        {!hasNotOpenedRestriction(ele) ? (
                          <>
                            <CheckCircleSolid />
                            <span className="font-medium text-xs mt-1">
                              {extractResource(resourceData, "checkedin")}
                            </span>
                          </>
                        ) : (
                          <span className="font-medium text-xs mt-1 text-typography-secondary">
                              {extractResource(resourceData, "flown")}
                            </span>
                        )}
                      </div>
                    ) : null}
                    <Box className="w-full block pl-2 text-xs">
                      {!checkForInternationalBooking(props?.currentBookingInState?.data?.data) && passangers &&
                        passangers.map((pass, index) => (
                          <RowFlex className="flex flex-row justify-between items-center" key={pass.key}>
                            <Typography className="text-xs">{pass.name}</Typography>
                            {paxSeats[pass.segmentKey] && paxSeats[pass.segmentKey][pass.key] && !hasNotOpenedRestriction(ele) ? (
                              <Button
                                key={`view-bp-${pass.key}`}
                                onClick={(e) => handleEye(e, pass.key, pass.segmentKey, pass.isInfant)}
                                className="cursor-pointer flex !pb-2"
                                variant = "text"
                              >
                                <Image src="/svg/eyeIcon.svg" alt="eye_icon" width={30} height={30} />
                                <p className="ml-2 text-typography-primary">{extractResource(resourceData, "view")}</p>
                              </Button>
                            ) : (
                              ""
                            )}
                          </RowFlex>
                        ))}
                    </Box>
                    {!hasNotOpenedRestriction(ele) && !ele?.isAnyCheckedIn? (
                      <Box>
                        <CheckingText>
                          <img src={AccessTime} alt="Access Time" />
                          {extractResource(resourceData, "onlineCheckInOpens48Hours")}
                        </CheckingText>
                      </Box>
                    ) : null}
                  </Box>
                </Box>
              </FCal1>
              {checkForInternationalBooking(props?.currentBookingInState?.data?.data) && ele.passengerSegment.filter((data) => data?.liftStatus == "CheckedIn").length > 0 && (
                <div className="pb-2">
                  <div className="border-b border-gray-300 mb-2"/>
                  <p className="text-xs text-typography-secondary">{extractResource(resources, "internationalVerifyDocumentsMessage")}</p>
                </div>
              )}
            </FCal>
          );
        })}
    </>
  );
}
export default ResCallenders;